export default function (value) {
  if (!value)
    return true;

  const date = value.split('/').reverse();

  const year = date[0];

  if (String(year).length < 4 || parseInt(year) < 1900) {
    return false;
  }

  const diffInMS = Date.now() - new Date(date.join('-')).getTime();

  const ageDt = new Date(diffInMS);

  const age = Math.abs(ageDt.getUTCFullYear() - 1970);

  return age >= 18 && age <= 110;
};
